<template>
  <component
    :is="($vuetify.display.smAndDown) ? 'v-bottomSheet' : 'v-dialog'"
    :max-width="$vuetify.display.smAndDown ? undefined : width"
    :persistent="!closable"
    @close="open = false"
    v-bind="$attrs"
    v-model="open"
  >
    <v-card
      rounded="lg"
      :class="['safe-area', cardClass]"
    >
      <div
        class="d-flex mb-4 align-center app-dialog-title-header"
        v-if="title || closable"
      >
        <h3>
          {{ title }}
        </h3>
        <v-spacer />
        <v-icon
          v-if="closable"
          icon="close"
          class="app-dialog-close"
          @click="open = false"
        />
      </div>

      <slot />
    </v-card>
  </component>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import {VBottomSheet} from "vuetify/components/VBottomSheet"
import {VDialog} from "vuetify/components/VDialog"

export default defineComponent({
  components: {VDialog, VBottomSheet},
  inheritAttrs: false,
  emits: ['update:modelValue', 'close'],
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    width: {
      type: [String, Number],
      default: 550
    },
    cardClass: {
      type: String,
      default: 'pa-8'
    },
    closable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
    }
  },
  computed: {
    open: {
      get() {
        return this.modelValue
      },
      set(value: boolean) {
        this.$emit('update:modelValue', value)
        if (!value) {
          this.$emit('close')
        }
      }
    }
  }
})
</script>

<style scoped>

/**
 * Setting a max height for mobiles, so the dialog not to show under the clock
 */
.safe-area {
  max-height:     calc(100dvh - var(--v-safe-area-top)) !important;
  padding-right:  var(--v-safe-area-right);
  padding-bottom: var(--v-safe-area-bottom);
  padding-left:   var(--v-safe-area-left);
}

</style>
